import React from "react";
import { Heading, VStack, Text, Box } from "native-base";
import { Link as RRDLink } from "react-router-dom";
import Image from "../../components/image";
import notFound from "../../assets/images/notFound.png";
import colors from "../../constants/colors";
import routes from "../../routes";

function NoTickets() {
  return (
    <VStack space={10} alignItems="center" justifyContent="center">
      <Box height="180" width="220">
        <Image image={notFound} alt="profile" />
      </Box>
      <Heading fontSize="2xl" color={colors.text} fontWeight="700">
        ¡No tienes boletos!
      </Heading>
      <VStack>
        <Heading fontSize="xl" color={colors.text} fontWeight="400">
          En este momento, no dispones de boletos;
        </Heading>
        <Heading fontSize="xl" color={colors.text} fontWeight="400">
          te invitamos a reservarlos ahora mismo.
        </Heading>
      </VStack>
      <RRDLink to={routes.home}>
        <Box
          paddingY={2}
          paddingX={5}
          backgroundColor={colors.primary}
          borderColor={colors.primary}
          borderWidth={1}
          borderRadius={5}>
          <Text color={colors.white}>Reserva ya</Text>
        </Box>
      </RRDLink>
    </VStack>
  );
}

export default NoTickets;
